import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { translateData } from 'utils/translation';
import AccountDetails from './AccountDetails';
import BillingInformation from './BillingInformation';
import DeliveryInformation from './DeliveryInformation';
import Header from './Header';
import RecurringOrder from './RecurringOrder';
import Bottom from './Bottom';
import styles from './styles.scss';
import OrderEditor from '../PrimoAccount/OrderEditor';
import CustomerNotesDrawer from './DeliveryInformation/CustomerNotesDrawer';

function AccountProfile() {
  return (
    <Fragment>
      <Header />
      <div className={styles.content}>
        <RecurringOrder />
        <AccountDetails />
        <DeliveryInformation />
        <BillingInformation />
        <OrderEditor />
        <CustomerNotesDrawer />
      </div>
      <Bottom />
      <Helmet title={translateData('My Profile')} />
    </Fragment>
  );
}

export default AccountProfile;
